import styled, { css } from 'styled-components';
import { COLOURS, GRADIENTS, isFocused, media, Z_INDEX } from '@belong/themes';
import { ButtonUnstyled, withLink } from '@belong/ui-components';

export const HEIGHT = 56; // px
export const HEIGHT_WITH_UNIT = '5.6rem';

export const Root = styled.div`
  ${media('lg')`
    display: none;
  `}
`;

export const RelativeContainer = styled.nav`
  position: relative;
`;

export const HeaderBarMobile = styled.div`
  background-color: ${COLOURS.BLACK};
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  min-height: ${HEIGHT_WITH_UNIT};
`;

export const HeaderBarLeftArea = styled.div`
  justify-self: start;
  display: flex;
  justify-content: center;
`;

export const HeaderBarMiddleArea = styled.div`
  justify-self: center;
  display: flex;
  justify-content: center;
`;

export const HeaderBarRightArea = styled.div`
  justify-self: end;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WrapperModal = styled.div``;

export const MenuButton = styled(ButtonUnstyled)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${HEIGHT_WITH_UNIT};
  width: ${HEIGHT_WITH_UNIT};
  cursor: pointer;

  &:focus {
    ${() => isFocused(true)}
  }
`;

export const LinkLogo = withLink<{ onClick: () => void }>(
  styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${HEIGHT_WITH_UNIT};
    padding-left: 2rem;
    padding-right: 2rem;
    text-decoration: none;
    max-width: 70vw;

    &:focus {
      ${() => isFocused(true)}
    }
  ` as any
);

export const SearchButton = styled(ButtonUnstyled)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${HEIGHT_WITH_UNIT};
  width: ${HEIGHT_WITH_UNIT};
  cursor: pointer;

  &:focus {
    ${() => isFocused(true)}
  }
`;

const offCanvasCommon = css`
  position: fixed;
  z-index: ${Z_INDEX.GLOBAL_HEADER};
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: ${COLOURS.BLACK};
  overflow-y: auto;
  will-change: transform, visibility;
  transition:
    transform 0.3s ease,
    visibility 0.3s ease;
  visibility: hidden;
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

export const OffCanvasMenu = styled.ul<{
  isExpanded: boolean;
}>`
  ${offCanvasCommon};

  transform: translateX(-100%);
  padding-top: 0.5rem;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      transform: translateX(0);
      visibility: visible;
    `}

  ${media('lg')`
      display: none;
    `}

  li:last-child {
    margin-top: auto;
    padding-bottom: 3.2rem;
  }
`;

export const OffCanvasSearch = styled.section<{
  isExpanded: boolean;
}>`
  ${offCanvasCommon};

  transform: translateX(100%);
  padding-top: 0.5rem;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      transform: translateX(0);
      visibility: visible;
    `}
`;

export const OffCanvasLinkPanel = styled.section<{
  isCenter: boolean;
  offCanvasLeft: boolean;
}>`
  ${offCanvasCommon};

  transform: translateX(100%);
  padding-top: 0.75rem;

  ${({ isCenter }) =>
    isCenter &&
    css`
      transform: translateX(0);
      visibility: visible;
    `}
  ${({ offCanvasLeft }) =>
    offCanvasLeft &&
    css`
      transform: translateX(-100%);
      visibility: visible;
    `}
`;

export const AccentStrip = styled.div<{ originRight?: boolean; isExpanded: boolean; ref: any }>`
  height: 0.8rem;
  min-height: 0.8rem; // prevent item collapse on small screens
  background: ${GRADIENTS.ACCENT_STRIP_GLOBAL_HEADER};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${Z_INDEX.GLOBAL_HEADER + 1};
  transform: ${({ originRight }) => `translate3d(${originRight ? '100%' : '-100%'}, 0, 0)`};
  transition: transform 0.3s ease;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      transform: translate3d(0, 0, 0);
      visibility: visible;
    `}
`;

export const StyledHR = styled.hr`
  margin: 1.6rem 3rem;
  color: ${COLOURS.GREY_500};
`;

export const StyledSearch = styled.div`
  padding: 0 2rem 3.2rem;
`;

export const LinkWrapper = styled.li`
  list-style: none;
`;
